import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';

import CustomerGroupQuery from '../../components/Query/CustomerGroup';
import CustomerGroupDetail from './CustomerGroupDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface ICustomerGroupTableProps extends RouteComponentProps {
  domain: string;
  groupId?: string;
}

class CustomerGroupTable extends React.Component<ICustomerGroupTableProps> {

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <CustomerGroupQuery>
            {({ customerGroupList, createCustomerGroup, updateCustomerGroup, deleteCustomerGroup }: any) => {
              return this.renderData(
                customerGroupList,
                createCustomerGroup,
                updateCustomerGroup,
                deleteCustomerGroup,
                customerGroupList.refetch
              );
            }}
          </CustomerGroupQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    customerGroupList: any,
    createCustomerGroup: Function,
    updateCustomerGroup: Function,
    deleteCustomerGroup: Function,
    refetch: Function
  ) {
    if (customerGroupList && !customerGroupList.loading) {

      // formulář
      if (this.props && this.props.groupId) {
        const selectedDeliveryMethod = customerGroupList.customerGroupList.find((s: GQL.IStore) => s.id === this.props.groupId) || undefined;
        if (this.props.groupId !== 'new' && !selectedDeliveryMethod) {
          return <NotFoundPage domain={this.props.domain} />
        }

        return (
          <CustomerGroupDetail
            domain={this.props.domain}
            languages={customerGroupList.languages}
            customerGroup={customerGroupList.customerGroupList.find((s: GQL.IStore) => s.id === this.props.groupId) || undefined}
            customerGroupList={customerGroupList.customerGroupList}
            onSave={a => this.upsert(a, createCustomerGroup, updateCustomerGroup, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }

      return (
        <div>
          <Title>Customer group</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>
            {`Create customer group`}
          </Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={customerGroupList.customerGroupList}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Name"
              dataIndex="name"
              key="name"
            />
            <Table.Column
              title="Discount"
              dataIndex="discount"
              key="discount"
              width={95}
              align="center"
              render={(u, row: GQL.ICustomerGroup) => {
                if (!row.discount) {
                  return null;
                }

                return `${row.discount} %`;
              }}
            />
            <Table.Column
              width={180}
              title="Actions"
              dataIndex="actions"
              key="actions"
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteCustomerGroup, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading customer groups ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(
    u: any,
    customerGroup: GQL.ICustomerGroup,
    deleteCustomerGroup: Function,
    refetch: Function
  ) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(customerGroup.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(customerGroup, deleteCustomerGroup, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(customerGroup: GQL.ICustomerGroup, deleteCustomerGroup: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${customerGroup.name}?`,
      content: (
        <span>
          Are you sure you want to delete customer group <strong>{customerGroup.name}</strong>
        </span>
      ),
      onOk: () => {
        return deleteCustomerGroup({
          variables: {
            id: customerGroup.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    customerGroup: GQL.ICustomerGroup,
    createCustomerGroup: Function,
    updateCustomerGroup: Function,
    refetch: Function
  ) {
    if (customerGroup != undefined) {
      const variables = {
        id: customerGroup.id,
        customerGroup: {
          name: customerGroup.name,
          discount: customerGroup.discount,
          fields: customerGroup.fields,
          description: customerGroup.description,
          email: customerGroup.email,
          PohodaIDS: customerGroup.PohodaIDS,
        }
      };

      if (customerGroup.id) {
        return updateCustomerGroup({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Customer group "${variables.customerGroup.name}" has been updated.`
            })
          );
      }

      (variables as any).domain = this.props.domain;

      createCustomerGroup({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Customer group "${variables.customerGroup.name}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/customerGroup${recordId ? `/${recordId}` : ''}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(CustomerGroupTable);



// WEBPACK FOOTER //
// ./src/scenes/CustomerGroup/CustomerGroupTable.tsx